import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image }) => {
  const siteUrl = 'https://www.collabpa.com';
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || `${siteUrl}/og-image.jpg`} />
      <meta property="og:url" content={siteUrl} />
      <link rel="canonical" href={siteUrl} />
    </Helmet>
  );
};

export default SEO;